import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  min-width: 0;
  padding: 2rem 0;
  position: relative;

  & > div {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    color: #000;
  }
`;

export const AbsoluteContainer = styled.section`
  position: absolute;
  bottom: 0;
  margin-bottom: 25px;
  max-width: 800px;
  width: 100%;
  height: 100px;
  background-color: #fff;
  border-radius: 8px;
`;
